import Currencies from "./Currencies";

export default Currencies;
